import React, { Component } from 'react'
import png from '@/assets/ba.png'
import FooterWrapper from './style'
export default class Footer extends Component {
  render() {
    return (
      <FooterWrapper className="footer-bar">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
          闽ICP备2023001148号-1
        </a>

        {/* <a href="https://beian.miit.gov.cn/">闽ICP备2023001148号</a> */}
        <img src={png} alt="" />
        <a href="https://beian.miit.gov.cn/"> 闽公网安备 35010202001644号</a>
      </FooterWrapper>
    )
  }
}
